import * as generics from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import defer from '@mailobj-browser/front/js/tree/defer.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { elements } from '../../styles.js'

export const play = async (audio, call) => {
  if (!call.contains(audio)) {
    return true
  }

  try {
    await audio.play()

    return true
  } catch {}
}

export const pause = (audio) => {
  audio.pause()
  audio.currentTime = 0
}

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const container = button.closest(`.${elements.meet_controls}`)
    const audio = one('audio', container)

    audio.remove()
  }
})

export default container => {
  const button = one(`.${generics.elements.button}`, container)
  const audio = one('audio', container)

  if (audio !== null) {
    onClick.listen(button)
    defer(audio, play, container)
  }
}